import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a89a796755b8c001446c6f5_1787788969172_9076f4f0/windglobe/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a89a796755b8c001446c6f5_1787788969172_9076f4f0/windglobe/src/app/globals.css");
